import React from 'react'

import { CalendarDays } from "lucide-react"
 

import { Button } from "@/components/ui/button"
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"

const HooverInformation = ({children, label}:{children:any, label:string}) => {
  return (

    <HoverCard>
    <HoverCardTrigger asChild>
      <Button variant="link" className='p-1'>
        {children}
      </Button>
    </HoverCardTrigger>
    <HoverCardContent className="w-80 bg-white">
      <div className="flex justify-between space-x-1">
          <div className="flex items-center">
          {" "}
            <span className="text-xs text-muted-foreground ml-2">
              {label}
            </span>
        </div>
      </div>
    </HoverCardContent>
  </HoverCard>

    
  )
}


export default HooverInformation